var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FilterSuggestions } from "./FilterSuggestions";
import { connect } from 'react-redux';
import { Translate } from "../../I18N";
import PropertyConfigOption from "./PropertyConfigOption";
import Tip from "../../Layout/Tip";

class PropertyConfigOptions extends Component {
  render() {
    const { index, filter, type, canBeFilter } = this.props;
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Hide label",
        model: `template.data.properties[${index}].noLabel` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This property will be shown without the label.")
      )
      ), /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Required property",
        model: `template.data.properties[${index}].required` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "empty property tip" }, void 0, "You won't be able to save an entity if this property is empty."

      )
      )
      ), /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Show in cards",
        model: `template.data.properties[${index}].showInCard` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This property will appear in the library cards as part of the basic info."

      )
      )
      ),

      canBeFilter && /*#__PURE__*/
      _jsx("div", { className: "inline-group" }, void 0, /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Use as filter",
        model: `template.data.properties[${index}].filter` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Property as filter description" }, void 0, "This property will be used for filtering the library results. When properties match in equal name and field type with other entity types, they will be combined for filtering."



      )
      )
      ),
      filter && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Default filter",
        model: `template.data.properties[${index}].defaultfilter` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Property as default filter description" }, void 0, "Use this property as a default filter in the library. When there are no entity types selected, this property will show as a default filter for your collection."



      )
      )
      ),
      ['text', 'date', 'numeric', 'select'].includes(type) && /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Priority sorting",
        model: `template.data.properties[${index}].prioritySorting` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Priority sorting description" }, void 0, "Properties marked as priority sorting will be used as default sorting criteria. If more than one property is marked as priority sorting the system will try to pick-up the best fit. When listing mixed template types, the system will pick-up the best combined priority sorting."




      )
      )
      )

      )

      ), /*#__PURE__*/

      _jsx(FilterSuggestions, { index: index })
      ));

  }
}

PropertyConfigOptions.defaultProps = {
  canBeFilter: true,
  filter: false
};








export function mapStateToProps({ template }, props) {
  return {
    filter: template.data.properties[props.index].filter
  };
}

export default connect(mapStateToProps)(PropertyConfigOptions);